/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Bookmarks_Yet_Click_Add_CInputs */

const en_no_bookmarks_yet_click_add_c = /** @type {(inputs: No_Bookmarks_Yet_Click_Add_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No bookmarks yet. Click "Add Current" to bookmark this page.`)
};

const es_no_bookmarks_yet_click_add_c = /** @type {(inputs: No_Bookmarks_Yet_Click_Add_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay marcadores. Haz clic en "Agregar actual" para guardar esta página.`)
};

const fr_no_bookmarks_yet_click_add_c = /** @type {(inputs: No_Bookmarks_Yet_Click_Add_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun signet pour le moment. Cliquez sur "Ajouter l'actuelle" pour ajouter cette page aux signets.`)
};

const de_no_bookmarks_yet_click_add_c = /** @type {(inputs: No_Bookmarks_Yet_Click_Add_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Lesezeichen. Klicke auf "Aktuelle hinzufügen", um diese Seite zu speichern.`)
};

const ja_no_bookmarks_yet_click_add_c = /** @type {(inputs: No_Bookmarks_Yet_Click_Add_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだブックマークはありません。「現在のページを追加」をクリックしてブックマークしてください。`)
};

const zh_no_bookmarks_yet_click_add_c = /** @type {(inputs: No_Bookmarks_Yet_Click_Add_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无书签。点击“添加当前页”将此页加入书签。`)
};

const ar_no_bookmarks_yet_click_add_c = /** @type {(inputs: No_Bookmarks_Yet_Click_Add_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد إشارات مرجعية بعد. انقر على "إضافة الحالية" لوضع إشارة مرجعية على هذه الصفحة.`)
};

const id_no_bookmarks_yet_click_add_c = /** @type {(inputs: No_Bookmarks_Yet_Click_Add_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada penanda. Klik "Tambahkan Saat Ini" untuk menandai halaman ini.`)
};

const it_no_bookmarks_yet_click_add_c = /** @type {(inputs: No_Bookmarks_Yet_Click_Add_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessun segnalibro. Clicca su "Aggiungi Corrente" per aggiungere questa pagina ai segnalibri.`)
};

const ru_no_bookmarks_yet_click_add_c = /** @type {(inputs: No_Bookmarks_Yet_Click_Add_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пока нет закладок. Нажмите «Добавить текущую», чтобы добавить эту страницу в закладки.`)
};

const pt_no_bookmarks_yet_click_add_c = /** @type {(inputs: No_Bookmarks_Yet_Click_Add_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum favorito ainda. Clique em "Adicionar Atual" para favoritar esta página.`)
};

const ko_no_bookmarks_yet_click_add_c = /** @type {(inputs: No_Bookmarks_Yet_Click_Add_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 북마크가 없습니다. '현재 페이지 추가'를 클릭하여 북마크하세요.`)
};

/**
* | output |
* | --- |
* | "No bookmarks yet. Click \"Add Current\" to bookmark this page." |
*
* @param {No_Bookmarks_Yet_Click_Add_CInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_bookmarks_yet_click_add_c = /** @type {((inputs?: No_Bookmarks_Yet_Click_Add_CInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Bookmarks_Yet_Click_Add_CInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_bookmarks_yet_click_add_c(inputs)
	if (locale === "es") return es_no_bookmarks_yet_click_add_c(inputs)
	if (locale === "fr") return fr_no_bookmarks_yet_click_add_c(inputs)
	if (locale === "de") return de_no_bookmarks_yet_click_add_c(inputs)
	if (locale === "ja") return ja_no_bookmarks_yet_click_add_c(inputs)
	if (locale === "zh") return zh_no_bookmarks_yet_click_add_c(inputs)
	if (locale === "ar") return ar_no_bookmarks_yet_click_add_c(inputs)
	if (locale === "id") return id_no_bookmarks_yet_click_add_c(inputs)
	if (locale === "it") return it_no_bookmarks_yet_click_add_c(inputs)
	if (locale === "ru") return ru_no_bookmarks_yet_click_add_c(inputs)
	if (locale === "pt") return pt_no_bookmarks_yet_click_add_c(inputs)
	return ko_no_bookmarks_yet_click_add_c(inputs)
});